"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseTabs = void 0;

var _react = _interopRequireWildcard(require("react"));

var _flattenChildren = require("../../helpers/flattenChildren");

var _Box = require("../Box");

var _HorizontalOverflow = require("../HorizontalOverflow/HorizontalOverflow");

var _Join = require("../Join");

var _excluded = ["fill", "children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** Extends `Box`, provides configurable gutter */
var BaseTabs = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var fill = _ref.fill,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var cells = (0, _react.useMemo)(function () {
    return (0, _flattenChildren.flattenChildren)(children);
  }, [children]);
  return /*#__PURE__*/_react.default.createElement(_HorizontalOverflow.HorizontalOverflow, _extends({
    ref: forwardedRef,
    borderBottom: "1px solid",
    borderBottomColor: "black10"
  }, rest), /*#__PURE__*/_react.default.createElement(_Join.Join, {
    separator: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, cells.map(function (child, i) {
    return /*#__PURE__*/_react.default.createElement(_Box.Box, {
      key: i,
      display: "inline-flex",
      textAlign: "center",
      flex: fill ? 1 : undefined
    }, child);
  })));
});
exports.BaseTabs = BaseTabs;
BaseTabs.displayName = "BaseTabs";
//# sourceMappingURL=BaseTabs.js.map